import { useObserver } from 'mobx-react-lite'
import React, { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'
import IAReadOnlyField from './IAReadOnlyField'
import classNames from 'classnames'

interface IADoorLevelSizeQuantitiesProps {
  doorProduct: any
  IADoorProduct: any
  showProductSizes: boolean
  disabled: boolean
  hasCaptureSize: boolean
  sizesElement?: any
}

const useStyles = makeStyles(theme => ({
  sizeQuantitiesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 'max-content',
    width: '100%'
  },
  sizeInput: {
    width: 60,
    height: 20,
    marginTop: 0
  },
  inactiveSize: {
    opacity: 0.5
  },
  totalSizes: {
    height: 90
  },
  lesserHeightSize: {
    height: 80
  }
}))

const IADoorLevelSizeQuantities: FC<IADoorLevelSizeQuantitiesProps> = ({
  doorProduct,
  IADoorProduct,
  showProductSizes,
  disabled,
  hasCaptureSize,
  sizesElement
}) =>
  useObserver(function useHook() {
    const { t } = useTranslation()
    const classes = useStyles()

    if (!hasCaptureSize) {
      return null
    }

    return (
      <div
        className={classes.sizeQuantitiesContainer}
        data-test-id='IADoorLevelSizeQuantities'
      >
        <div
          className={classNames(classes.totalSizes, {
            [classes.lesserHeightSize]: showProductSizes
          })}
        >
          <IAReadOnlyField
            label={t('order.initialAllocation.totalIASizedQty', 'Total / IA Sized Qty')}
            value={`${doorProduct?.doorOrderProductSizeQuantity || 0} / ${
              IADoorProduct?.deliverySizeQuantity || 0
            }`}
            noBottomBorder={true}
          />
        </div>
        <div>{sizesElement}</div>
      </div>
    )
  })

export default memo(IADoorLevelSizeQuantities)
